import 'es6-promise/auto'
import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueGtag from 'vue-gtag'
import VueGtm from 'vue-gtm'
import Flickity from 'vue-flickity'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'
import ScrollToPlugin from 'gsap/ScrollToPlugin'
import VueMq from 'vue-mq'
Vue.config.productionTip = false
Vue.use(Flickity)

Vue.use(VueMq, {
  breakpoints: {
    sm: 450,
    lg: Infinity
  }
})

gsap.core.globals('ScrollTrigger', ScrollTrigger)
gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(ScrollToPlugin)
Vue.prototype.$ScrollTrigger = ScrollTrigger
Vue.prototype.$gsap = gsap

// fb
Vue.prototype.$fbq = window.fbq

// gtag
Vue.use(VueGtag, {
  config: {
    id: 'UA-60734666-6'
  }
})
// kakao pixel
Vue.prototype.$kakaoPixel = window.kakaoPixel

// gtm
Vue.use(VueGtm, {
  id: 'GTM-NSBQWCX'
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
